export class Ecommerce_Config {
    public static api_url: string = 'https://www.mdmacrm.com:3000/';
    public static page_title: string = 'Dashboard';
    public static max_file_size: number = 1e+6;
    public static img_url: string = 'https://www.mdmacrm.com/server/';
}